import { SelectOption } from '@/ui-kit';
import { httpService, upsertItemToArray } from '@/utils';
import { computed, reactive } from 'vue';

export type VirtualMailboxAddress = {
	id: number;
	address_line_1: string;
	address_line_2: string;
	state: string;
	zip: string;
	city: string;
	created_at: string;
	updated_at: string;
};

type CreateVirtualMailboxAddressPayload = {
	address_line_1: string;
	address_line_2: string;
	city: string;
	state: string;
	zip: string;
};

type VirtualMailboxAddressesState = {
	isLoading: boolean;
	addresses: VirtualMailboxAddress[];
};

const state = reactive<VirtualMailboxAddressesState>({
	isLoading: true,
	addresses: []
});

export function useVirtualMailboxAddresses() {
	async function loadAddresses() {
		state.isLoading = true;
		try {
			const addresses = await httpService.get<
				VirtualMailboxAddress[]
			>('/company/virtual-mailbox/addresses');
			state.addresses = addresses;
		} catch (e) {
			console.log('Failed loading addresses', e);
		} finally {
			state.isLoading = false;
		}
	}

	async function createAddress(
		payload: CreateVirtualMailboxAddressPayload
	) {
		const addresses = await httpService.post<
			VirtualMailboxAddress[]
		>('/company/virtual-mailbox/addresses', payload);
		state.addresses = addresses;
	}

	function toAddressString(
		address: VirtualMailboxAddress
	) {
		return `${[
			address.address_line_1,
			address.address_line_2
		]
			.filter((val) => !!val)
			.join(' ')}, ${address.city}, ${
			address.state
		} ${address.zip}`;
	}

	return {
		isLoading: computed(() => state.isLoading),
		addresses: computed(() => state.addresses),
		addressOptions: computed<SelectOption[]>(() =>
			state.addresses.map((address) => ({
				title: toAddressString(address),
				value: address.id
			}))
		),
		loadAddresses,
		createAddress,
		toAddressString
	};
}
